/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Blockedtill1Inputs */

const en__field_blockedtill1 = /** @type {(inputs: _Field_Blockedtill1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked until`)
};

const de__field_blockedtill1 = /** @type {(inputs: _Field_Blockedtill1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockert bis`)
};

/**
* | output |
* | --- |
* | "Blocked until" |
*
* @param {_Field_Blockedtill1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_blockedtill1 = /** @type {((inputs?: _Field_Blockedtill1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Blockedtill1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_blockedtill1(inputs)
	return de__field_blockedtill1(inputs)
});
export { _field_blockedtill1 as "_field_blockedTill" }